import WidgetGrid from "@components/widgets/Grid";
import { useParams } from "react-router-dom";
import { useFilterParamsV4 } from "@/hooks/useFilterParams";
import { withDefaultDates } from "@/utils";
import { differenceInDays } from "date-fns";
import ChannelCountWidget from "./partials/widgets/ChannelCount";
import EpisodeCountWidget from "./partials/widgets/EpisodeCount";
import ChannelTypesByMentionCountWidget from "@components/widgets/ChannelTypesByMentionCount";
import TopChannelTypeWidget from "./partials/widgets/TopChannelType";
import MentionsOverTimeWidget from "@components/widgets/MentionsOverTime";
import TopSourcesWidget from "./partials/widgets/TopSources";
import TopTermsWidget from "./partials/widgets/TopTerms";
import MentionCountWidget from "./partials/widgets/MentionCount";

export default function MentionsInsightsResultsView() {
  // URL state
  const { uuid } = useParams<{ uuid: Uuid }>();
  const [_filters] = useFilterParamsV4();

  // Helpers
  const filters = withDefaultDates(_filters);
  const diffInDays = differenceInDays(filters.end_date, filters.start_date);

  return (
    <div className="flex flex-col gap-8" data-testid="insights-results-page">
      <WidgetGrid>
        <MentionCountWidget
          className="col-span-12 @4xl/grid:col-span-3 h-24"
          diffInDays={diffInDays}
          searchUuid={uuid}
          filters={filters}
        />

        <EpisodeCountWidget
          className="col-span-12 @4xl/grid:col-span-3 h-24"
          diffInDays={diffInDays}
          searchUuid={uuid}
          filters={filters}
        />

        <ChannelCountWidget
          className="col-span-12 @4xl/grid:col-span-3 h-24"
          searchUuid={uuid}
          filters={filters}
        />

        <TopChannelTypeWidget
          className="col-span-12 @4xl/grid:col-span-3 h-24"
          searchUuid={uuid}
          filters={filters}
        />

        <MentionsOverTimeWidget
          className="col-span-12 @4xl/grid:col-span-8 h-96"
          searchUuid={uuid}
          diffInDays={diffInDays}
          filters={filters}
          hideTotals
        />

        <ChannelTypesByMentionCountWidget
          className="col-span-12 @4xl/grid:col-span-4 h-96"
          searchUuid={uuid}
          filters={filters}
        />

        <TopSourcesWidget
          className="col-span-12"
          searchUuid={uuid}
          filters={filters}
        />

        <TopTermsWidget
          className="col-span-12"
          diffInDays={diffInDays}
          searchUuid={uuid}
          filters={filters}
        />
      </WidgetGrid>
    </div>
  );
}
